module.exports = __webpack_public_path__ + "img/herco.252f1e28.jpeg";